import { createRoute, Link } from '@tanstack/react-router'
import { authLayoutRoute } from './_auth'
import { useSession } from '@/lib/auth'
import { RiAddLine } from '@remixicon/react'
import { Button } from '@/components/ui/button'
import { PlaylistGrid } from '@/components/playlist'

export const dashboardRoute = createRoute({
	getParentRoute: () => authLayoutRoute,
	path: '/',
	component: DashboardPage,
})

function DashboardPage() {
	const { data: session } = useSession()
	const user = session?.user

	return (
		<main className="relative flex-1">
			{/* Atmospheric gradient — subtle warm glow from top */}
			<div
				className="pointer-events-none absolute inset-x-0 top-0 h-72"
				style={{
					background: `radial-gradient(ellipse 80% 50% at 50% 0%, oklch(0.77 0.16 70 / 6%) 0%, transparent 100%)`,
				}}
			/>

			<div className="relative px-5 py-6">
				<div className="mx-auto max-w-5xl space-y-8">
					<div className="flex items-end justify-between gap-4">
						<div className="space-y-2">
							<h2 className="font-serif text-3xl font-semibold tracking-tight">
								Welcome back, {user?.name?.split(' ')[0]}
							</h2>
							<p className="text-sm text-muted-foreground">
								Select a playlist to start playing.
							</p>
						</div>
						<Button asChild size="sm">
							<Link to="/playlists/create">
								<RiAddLine className="size-3.5" />
								New Playlist
							</Link>
						</Button>
					</div>

					{/* Playlists grid */}
					<PlaylistGrid />
				</div>
			</div>
		</main>
	)
}
